/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_DownloadingInputs */

const en_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloading whisper model...`)
};

const fr_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement du modèle whisper...`)
};

const de_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whisper-Modell wird heruntergeladen...`)
};

const it_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download modello whisper...`)
};

const ru_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка модели whisper...`)
};

const es_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargando modelo whisper...`)
};

const zh_cn2_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在下载 whisper 模型...`)
};

const ja_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whisperモデルをダウンロードしています...`)
};

const hi_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्हिस्पर मॉडल डाउनलोड हो रहा है...`)
};

const pt_pt2_offline_sync_status_downloading = /** @type {(inputs: Offline_Sync_Status_DownloadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transferir modelo whisper...`)
};

/**
* | output |
* | --- |
* | "Downloading whisper model..." |
*
* @param {Offline_Sync_Status_DownloadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_downloading = /** @type {((inputs?: Offline_Sync_Status_DownloadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_DownloadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_status_downloading(inputs)
	if (locale === "de") return de_offline_sync_status_downloading(inputs)
	if (locale === "it") return it_offline_sync_status_downloading(inputs)
	if (locale === "ru") return ru_offline_sync_status_downloading(inputs)
	if (locale === "es") return es_offline_sync_status_downloading(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_status_downloading(inputs)
	if (locale === "ja") return ja_offline_sync_status_downloading(inputs)
	if (locale === "hi") return hi_offline_sync_status_downloading(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_status_downloading(inputs)
	return en_offline_sync_status_downloading(inputs)
});